module.exports = __webpack_public_path__ + "img/fabrixai-bg.97b588a0.svg";